var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-box"},[_c('Language'),_c('Social')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }